import { get } from "lodash";

export const cart = (state, submissionId) =>
  get(state, ["formsV2", "submissionCart", "byId", submissionId], []);

export const isFetchingBulk = state =>
  get(state, ["formsV2", "submissionCart", "fetchingBulk"], false);
